import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Login from '../views/loginView.vue'
import Cross from '../views/crossing.vue'
import Layout from '../views/Layout.vue'
import Unit from '../views/unit.vue'
import Log from '../views/log'
import Person from '../views/person'
import Casemanage from '../views/casemanage'
import Askmanage from '../views/askmanage'
import User from '../views/User/index'
import Role from '../views/role'
import Power from '../views/power'
import Askdetail from '../views/askdetail'
import Askdetails from '../views/askdetails'
import About from '../views/About'
import Home from '../views/Home'
import Invite from '../views/Invite'
import Dept from '../views/dept'
import Mobilepdf from '../views/mobilepdf'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login,
    // redirect: '/login'
  },
  {
    path: '/invite',
    component: Invite
  },
  {
    path: '/mobilepdf',
    component: Mobilepdf
  },
  {
    path: '/',
    component: Cross,
    // redirect: '/login'
  },
  {
    path: '',
    component: Layout,
    redirect: '/unit',
    hidden: true,
    children: [
      {
        path: '/unit',
        component: Unit
      },
      {
        path: '/log',
        component: Log
      },
      {
        path: '/manager/personal',
        component: Person
      }
      ,
      {
        path: '/record/case',
        component: Casemanage
      }
      ,
      {
        path: '/record/ask',
        component: Askmanage
      },
      {
        path: '/user/user',
        component: User
      },
      {
        path: '/user/dept',
        component: Dept
      },
      {
        path: '/user/role',
        component: Role
      },
      {
        path: '/user/auth',
        component: Power
      },
      {
        path: '/askdetail',
        component: Askdetail
      },
      {
        path: '/askdetails',
        component: Askdetails
      }
      ,
      {
        path: '/about',
        component: About
      }
      ,
      {
        path: '/home',
        component: Home
      },
      {
        path: '/record/evidence',
        component: () => import('../views/attest.vue')
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
